// extracted by mini-css-extract-plugin
module.exports = {"ratings-container":"Ratings_ratings-container__3Vvko","rating":"Ratings_rating__HyErv"};